// import { LoginProps, SignupProps, apiUrl } from "../utilities/type";
import { Redirect } from "react-router-dom";
import { LoginProps, SignupProps } from "../utilities/type";
import { PublicRoutes } from "../routes";
import { AxiosInstanceV1, AxiosInstanceV2 } from "..";
// const apiUrl = 'http://mazola-prod-apps-lb-1622676082.me-south-1.elb.amazonaws.com/api/v1';

// const apiUrl = 'https://api.mazola.com.sa/api/v1';
// const apiUrl = 'https://mazola-api-v2.herokuapp.com';
const apiUrl = 'https://mazola-api.onrender.com';


const isPublicRoute = (pathname:string) => Object.values(PublicRoutes).some(route => route === pathname);

const authProvider = {
    // authentication
    login: async ({ username, password }: LoginProps) =>  {
        try {
            const response = await AxiosInstanceV1.post('/signin', JSON.stringify({ username, password }));
            localStorage.setItem('auth', JSON.stringify(response));
            localStorage.setItem('role','admin');
            console.log('response', response);            
        } catch (error) {
            console.log('error', error);
        }

        // const request = new Request(`${apiUrl}/signin`, {
        //     method: 'POST',
        //     body: JSON.stringify({ username, password }),
        //     headers: new Headers({ 'Content-Type': 'application/json' }),
        // });
        // try {
        //         const response = await fetch(request);
        //         const auth = await response.json();
        //         localStorage.setItem('auth', JSON.stringify(auth));
        //         localStorage.setItem('role','admin')
        // } catch {
        //     throw new Error('Network error');
        // }
    },
    signup: async ({ username, email, password, role = 'admin' }: SignupProps) =>  {
        try {
            const response = await AxiosInstanceV1.post('/signup', JSON.stringify({ username, email, password, role }));
            localStorage.setItem('auth', JSON.stringify(response));
            localStorage.setItem('role','admin');
            console.log('response', response);            
        } catch (error) {
            console.log('error', error);
        }
        // const request = new Request(`${apiUrl}/signup`, {
        //     method: 'POST',
        //     body: JSON.stringify({ username, email, password, role }),
        //     headers: new Headers({ 'Content-Type': 'application/json' }),
        // });
        // try {
        //     const response = await fetch(request);
        //     if (response.status < 200 || response.status >= 300) {
        //         throw new Error(response.statusText);
        //     }
        //     const auth = await response.json();
        //     localStorage.setItem('auth', JSON.stringify(auth));
        // } catch {
        //     throw new Error('Network error');
        // }
    },
    checkError: (error: any) => Promise.resolve(),
    checkAuth: (params: any) => {
        const { pathname } = window.location;
        if (isPublicRoute(pathname)) {
            return Promise.resolve();
        }else{
            return localStorage.getItem('auth')
            ? Promise.resolve()
            : Promise.reject({ redirectTo: '/login' })
        }
        
    },
    logout: () => {
        localStorage.removeItem('auth');
        // @ts-ignore
        AxiosInstanceV2.defaults.headers['x-access-token'] = undefined;
        return Promise.resolve('/login');
    },
    getIdentity: () => {
        try {
            const { id, fullName, avatar } = JSON.parse(localStorage.getItem('auth') || '');
            return Promise.resolve({ id, fullName, avatar });
        } catch (error) {
            return Promise.reject(error);
        }
    },
    // authorization
    getPermissions: (params: any) => {
        const role = localStorage.getItem('role');
        return role ? Promise.resolve(role) : Promise.reject();
    }
};

export default authProvider;